module.exports = __webpack_public_path__ + "themes/fq/sprite/queenhand.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/queenhand.png
// module id = 72
// module chunks = d-game